import React, { Component } from 'react';
import { ApiRoutes } from "../../config";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Dropdown,
  Button,
  Form,
} from "react-bootstrap";

import { DatePicker } from "antd";
import { ICheckInProps, ICheckInState } from "../../interfaces/checkin";
import { IRootState } from "../../interfaces";
import { Dispatch } from "redux";
import { checkInUsingDateRequest } from '../../action';
import { connect } from "react-redux";
import Moment from 'moment'
import Loader from "../../components/Loader/Loader";

var attendanceTypeName = [
  // "Username",
  "Date",
  "Daily Scrum",
  "Sprint Planning",
  "Backlog Refinement",
  "Knowledge Share",
  "Sprint Review",
  "Sprint Retrospective",
  "Training",
  "Backlog Refinement 2",
  "CoP Meeting",
  "Scrum of Scrum",
  "Ad-Hoc Meeting",
];

var nextDate: any;
class DailyCheckIn extends Component<ICheckInProps, ICheckInState>{

  constructor(props: ICheckInProps) {
    super(props);
    this.state = {
      search: "",
      moduleName: "",
      endMessage: "",
      previewCss: "",
      module_id: "",
      subModile_ID: "",
      CheckInDataFaciliation: [],
      checkDate: "",
      CheckInDataAttendance: [],
      DropDownValue: "",
      disabled: [],
      temp: "",
      showSelectDate: "",
      SelectedDate: "",
      startDate:"",
      endDate:"",
      countdownDate: "",
      datapickerToggle: false,
    };
  }


  submitCheckIn = () => {
    console.log("BUton clicked");
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;
    console.log(
      "facilitation\n" + 
      startDate +
        "\n" +
        "Daily Check In \n" +
        endDate
    );
    const { getCheckInUsingDateData } = this.props;
    console.log("-------------------------------",this.props)
    const data = {
      startDate,
      endDate,
    };

    getCheckInUsingDateData({ ...data });

    console.log(getCheckInUsingDateData);

  };

  componentDidMount() {
    this.setState(
      {
        DropDownValue: "DailyCheckIn",
      },
      () => {
        console.log(this.state.DropDownValue);
      }
    );
   const todayDate = new Date().getTime();
    const date = new Date(todayDate);

    let startDate = this.state.startDate;
    // let endDate =  this.state.endDate;
    let endDate =  date.toLocaleDateString('sv');
    console.log(
      "facilitation\n" + 
      startDate +
        "\n" +
        "Daily Check In \n" +
        endDate
    );
    const { getCheckInUsingDateData } = this.props;
      
    const data = {
      startDate,
      endDate,
    };

    getCheckInUsingDateData({ ...data });
  }

  componentDidUpdate = (prevProps: ICheckInProps, prevState: ICheckInState) => {
    const { checkInReducer } = this.props;
    const { checkInData } = checkInReducer;
    console.log("dataaaaaaaaaaaaa", checkInData)
  };


  changeDropDownValue = (selectedDropDown: any) => {
    if (selectedDropDown === "DailyCheckIn") {
      this.setState(
        {
          DropDownValue: "DailyCheckIn",
        },
        () => {
          console.log(this.state.DropDownValue);
          document.getElementById("Daily")?.setAttribute("class", "dropdown-item active");
          document.getElementById("Facilitation")?.setAttribute("class", "dropdown-item");
        }
      );
    } else if (selectedDropDown === "Facilitation") {
      this.setState(
        {
          DropDownValue: "Facilitation",
        },
        () => {
          console.log(this.state.DropDownValue);          
          document.getElementById("Daily")?.setAttribute("class", "dropdown-item");
          document.getElementById("Facilitation")?.setAttribute("class", "dropdown-item active");
        }
      );
    }
  };
  closeDiv =()=>{

    this.setState(
      
        {DropDownValue: ""},
      );
    // console.log('i clickeddddddddddd')
  };

  render() {
    const { checkInReducer } = this.props;
    const { checkInData } = checkInReducer;
    return (
      <>
        <>
          <div className="main-section module-custom-main" id="right-container">
            <Col md={12} lg={12}>
              <Container>
                <div className="title video-search">
                  <div className="row">
                    <div className="filter-video-section">
                      <h1 className="video-title">
                        Check-In History
                        <span className="border-heading"></span>
                      </h1>

                    </div>
                  </div>
                </div>
                <div>

                </div>
                <div>
                  <div className={"filter-block"}>
                    <Form >
                      <Row>
                        <Col lg={"3"} md={"3"} className="mb-0">
                          <div>
                            <span className="from-to">
                              <strong>FROM : </strong>
                            </span>
                            <DatePicker format="DD-MM-YY"
                              style={{
                                borderLeftWidth: 0,
                                borderRightWidth: 0,
                                borderTopWidth: 0,
                              }}
                              onSelect={(date) => {
                                this.setState({
                                  startDate: date.format("YYYY-MM-DD HH:mm:ss"),
                                });
                              }}
                            />
                          </div>
                        </Col>
                        <Col lg={"3"} md={"3"} className="mb-0">
                          <div>
                          <span className="from-to">
                          <strong>TO : </strong>
                          </span>
                            <DatePicker format="DD-MM-YY"
                              style={{
                                borderLeftWidth: 0,
                                borderRightWidth: 0,
                                borderTopWidth: 0,
                              }}
                              onSelect={(date) => {
                                // console.log('date added',date.format("YYYY-MM-DD HH:mm:ss"))
                                this.setState({
                                  endDate: date.format("YYYY-MM-DD HH:mm:ss"),
                                });
                              }}
                            />
                          </div>
                        </Col>
                        <Col lg={"3"} md={"3"} className="mb-0">
                          <div>
                          <Button
                                disabled={this.state.endDate === ""}
                                onClick={this.submitCheckIn}
                                style={{ marginTop: "16px" }}
                                variant="warning"
                              >
                                Submit
                              </Button>
                          </div>
                        </Col>

                        <Col lg={"6"} md={"6"} className="mb-0">
                          <Dropdown style={{ marginTop: "30px" }}>
                            <Dropdown.Toggle variant="warning">
                              {this.state.DropDownValue === ""
                                ? "Select Attendance Type:"
                                : this.state.DropDownValue}

                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item
                                id="Daily"
                                onClick={() => {
                                  console.log('clickeddd')
                                  this.changeDropDownValue("DailyCheckIn");
                                }}
                                href="#"
                                active
                              >
                                Daily Check In
                              </Dropdown.Item>

                              <Dropdown.Item
                                id="Facilitation"
                                onClick={() => {
                                  this.changeDropDownValue("Facilitation");
                                  console.log('clickeddd2')
                                }}
                                href="#"
                              >
                                Ceremony Facilitation
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                  
                </div>

                {this.state.DropDownValue != "" ? (
                            <div
                              className="AttendanceDropDownContainer"
                              id="AttendanceDropDownContainer"
                            >
                             
                               {/*<Row>
                                    <Col>
                                      <button
                                        type="button"
                                        style={{
                                          float: "right",
                                          margin: "4px",
                                          border: "none",
                                          borderRadius: "50%",
                                          fontSize: "13px",
                                          textAlign: "center",
                                          
                                        }}
                                        onClick={this.closeDiv}
                                      >
                                        x
                                      </button>
                                    </Col>
                                      </Row>*/}
                              {this.state.DropDownValue === "DailyCheckIn" ? (
                                //  DailyCheckIn dropDown
                                <>
                                      <section className="">
              <div className="container daily-table-main"> 
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    {checkInReducer && checkInReducer.isLoading ? (
                      <Loader />
                    ) : (
                      <div className="filter-div">
                        <table className="table" >
                        <thead className="thead-color">
                  {attendanceTypeName.map((item, index) => {
                    return <th className="text-center">{item} </th>;
                  })}
                </thead>
                          <tbody>
                            {checkInReducer &&
                            checkInReducer.checkInData &&
                            checkInReducer.checkInData.length ? (
                              checkInReducer.checkInData.map(
                                
                                (item: any, index: any) => {
                                  console.log( "dataaaaaaaaa",checkInReducer.checkInData)
                                  return (
                                    <tr key={index}
                                    style={index % 2 === 0?{backgroundColor:"#fff"}:{}}
                                    // style = {backgroundColor: {index % 2 === 0 ? 'red' : 'blue'}}
                                    >                                
                                     
                                      <td className="text-left">{Moment(item.checkDate).format('DD/MM/YY')}</td>
                                      {
                                            item.attendance.split(",").map(
                                              (item: any, index: any) => {
                                                return (
                                                  
                                                  <td style={{textAlign: 'center'}}>
                                                    
                                                    {item === "1" ? 
                                                    <i style={{color:'green'}} className="fa fa-check-circle" aria-hidden="true"></i> :
                                                     <i style={{color:'red'}} className="fa fa-times-circle" aria-hidden="true"></i>}
                                                    
                                                    
                                                  </td>
                                                );
                                                })  
                                           
                                           }
                                    </tr>
                                  );
                                }
                              )
                            ) : (
                              /**** IF THE  STUDENT HAS NO QUIZES THEN  */

                              <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="box-main">
                                  {" "}
                                  <h6 className="text-center mandatory">
                                    No Module Found.{" "}
                                  </h6>
                                </div>{" "}
                              </div>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
                                </>
                              ) : (
                                
                                //  Facilitation dropDown
                                <>
                                      <section className="">
              <div className="container daily-table-main"> 
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    {checkInReducer && checkInReducer.isLoading ? (
                      <Loader />
                    ) : (
                      <div className="filter-div">
                        <table className="table" >
                        <thead className="thead-color">
                  {attendanceTypeName.map((item, index) => {
                    return <th className="text-center">{item} </th>;
                  })}
                </thead>
                          <tbody>
                            {checkInReducer &&
                            checkInReducer.checkInData &&
                            checkInReducer.checkInData.length ? (
                              checkInReducer.checkInData.map(
                                
                                (item: any, index: any) => {
                                  console.log( "dataaaaaaaaa",checkInReducer.checkInData)
                                  return (
                                    <tr key={index}
                                    style={index % 2 === 0?{backgroundColor:"#fff"}:{}}
                                    // style = {backgroundColor: {index % 2 === 0 ? 'red' : 'blue'}}
                                    >                                
                                     
                                      <td className="text-left">{Moment(item.checkDate).format('DD/MM/YY')}</td>
                                      {
                                            item.facilitation.split(",").map(
                                              (item: any, index: any) => {
                                                    return (
                                                      <td style={{textAlign: 'center'}}>
                                                        {item === "1" ? 
                                                        <i style={{color:'green'}} className="fa fa-check-circle" aria-hidden="true"></i> :
                                                         <i style={{color:'red'}} className="fa fa-times-circle" aria-hidden="true"></i>}
                                                      
                                                      
                                                      </td>
                                                    );
                                                  })}
                                    </tr>
                                  );
                                }
                              )
                            ) : (
                              /**** IF THE  STUDENT HAS NO QUIZES THEN  */

                              <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="box-main">
                                  {" "}
                                  <h6 className="text-center mandatory">
                                    No Module Found.{" "}
                                  </h6>
                                </div>{" "}
                              </div>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
                                </>
                              )}
                            </div>
                          ) : (
                            ""
                          )}
              </Container>
            </Col>
          </div>
        </>
      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  checkInReducer: state.checkInReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getCheckInUsingDateData: (data: any) => {
      dispatch(checkInUsingDateRequest(data));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DailyCheckIn);